import ReactGA, { EventArgs } from "react-ga";
import useGoogleAnalytics from "./useGoogleAnalytics";

const useGoogleAnalyticsTracking = () => {
  const initialized = useGoogleAnalytics();

  if (!initialized) {
    return {
      initialized
    };
  }

  return {
    initialized,
    sendUserEvent: ({ userId, ...event }: {
      userId: string;
    } & EventArgs) => {
      ReactGA.set({ userId });
      ReactGA.event(event);
    }
  };
};

export default useGoogleAnalyticsTracking;
